import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  statusText: {
    color: theme.palette.accent,
  },
  rowBaseStyle: { borderLeft: `5px solid transparent` },

  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },
  footerRow: {
    backgroundColor: theme.palette.neutralLighter,
  },
  amountStack: {
    fontWeight: 'bold',
  },
  onrenderColumnStack: {
    height: 25,
  },
  container: { maxWidth: 300, minWidth: 200 },
  containerMain: { padding: 0, margin: 0 },
  title: { color: theme.palette.white },
  urgentHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '5px 10px',
    backgroundColor: `${theme.palette.redDark}`,
  },
}));
